var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { useContext } from "react";
import { ThemeContext } from "styled-components";
import PropTypes from "prop-types";
import { breakPointArrayCleaner, breakPointArrayCleanerRem } from "../../utils";
import { cleanGutterTrueFalse } from "./utils";
import { TypographyStyled } from "./atoms";

var Typography = React.forwardRef(function (props, ref) {
  var theme = useContext(ThemeContext);

  var children = props.children,
      $as = props.$as,
      size = props.size,
      gutterBottom = props.gutterBottom,
      color = props.color,
      restProps = _objectWithoutProperties(props, ["children", "$as", "size", "gutterBottom", "color"]);

  if (theme.colors[color]) {
    color = theme.colors[color];
  } else if (theme[color]) {
    color = theme[color];
  }

  size = breakPointArrayCleaner(size);

  gutterBottom = breakPointArrayCleanerRem(gutterBottom);
  gutterBottom = cleanGutterTrueFalse(gutterBottom, size);

  return React.createElement(
    TypographyStyled,
    _extends({
      forwardedRefSafe: ref,
      $as: $as,
      size: size,
      gutterBottom: gutterBottom,
      color: color
    }, restProps),
    children
  );
});

export { Typography };
Typography.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  $as: PropTypes.string,
  display: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
  bold: PropTypes.bool,
  gutterBottom: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]))]),
  color: PropTypes.string,
  uppercase: PropTypes.bool
} : {};

Typography.defaultProps = {
  $as: "p",
  display: "block",
  size: [1, 1, 1.25],
  bold: false,
  gutterBottom: false,
  color: "textMedium",
  uppercase: false
};